import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWindowDockedSidepanelLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "scale(1.2)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14.3467 2.70831C15.7294 2.70831 16.8984 3.20135 17.7183 4.08201C18.5332 4.95762 18.9569 6.16679 18.9569 7.52277V12.478C18.9568 13.8339 18.5334 15.0432 17.7183 15.9188C16.8983 16.7993 15.7288 17.2916 14.3459 17.2916H5.65202C4.26949 17.2916 3.10041 16.7992 2.28044 15.9188C1.46521 15.0433 1.0411 13.834 1.04102 12.478V7.52277C1.04102 6.16608 1.46716 4.95719 2.28288 4.08201C3.10343 3.20194 4.27254 2.70831 5.65202 2.70831H14.3467ZM5.65202 3.95913C4.58225 3.95913 3.75757 4.33354 3.19759 4.93406C2.63321 5.5395 2.29102 6.42566 2.29102 7.52277V12.478C2.2911 13.5758 2.63184 14.4617 3.19515 15.0667C3.75386 15.6666 4.57824 16.0416 5.65202 16.0416H14.3459C15.4201 16.0416 16.245 15.6665 16.8035 15.0667C17.3666 14.4618 17.7068 13.5758 17.7069 12.478V7.52277C17.7069 6.42496 17.3665 5.53909 16.8035 4.93406C16.245 4.33408 15.4206 3.95913 14.3467 3.95913H5.65202ZM14.5827 5.41665C15.5032 5.41665 16.2493 6.16284 16.2493 7.08331V12.9166C16.2493 13.8371 15.5032 14.5833 14.5827 14.5833H12.0827C11.6224 14.5833 11.2493 14.2102 11.2493 13.75V6.24998C11.2493 5.78974 11.6224 5.41665 12.0827 5.41665H14.5827Z",
			fill: "currentColor"
		})
	})
});
export default SvgWindowDockedSidepanelLine;
